import ModelMarshaller from './ModelMarshaller';
import OrderItem from './OrderItem';
import UserRepository from '../repository/UserRepository';
import ArticleMarshaller from './ArticleMarshaller';

export default class OrderItemMarshaller extends ModelMarshaller<OrderItem> {

    private userRepository = new UserRepository()
  

    toJSON() {
        if (this.data instanceof OrderItem) {
            return {
                id: this.data.$id,
                name: this.data.$user.$name,
                payed: this.data.$payed,
                pizza: new ArticleMarshaller(this.data.$article).toJSON(),
                size: this.data.$size
            }
        }
        return this.data;
    }
    
    toModel(): OrderItem {
        if (this.data instanceof OrderItem) {
            return this.data
        }

        let user = this.userRepository.findByFullnameOrCreate(this.data.customer);
        let article = new ArticleMarshaller(this.data.pizza).toModel();
        return new OrderItem(this.data.id,user,article,article.$prices[0].$name ,this.data.creationTime,Boolean(this.data.payed));
    }

    
}